import { upload } from '@/api/upload'

export default {
  data() {
    return {
      fileList: [],
      completedProgress: 0,
      max: 1 // MB
    }
  },
  methods: {
    beforeUpload(file) {
      let { max } = this
      const isLt2M = file.size / 1024 / 1024 < max
      if (!isLt2M) {
        this.$message.error(`文件必须小于${max}MB!`)
        return false
      }
      let index = Array.prototype.findIndex.call(
        this.fileList,
        ele => ele.name === file.name
      )
      if (index === -1) {
        this.fileList = [...this.fileList, file]
      }
      return false
    },
    beforeRemove(file) {
      let index = Array.prototype.findIndex.call(
        this.fileList,
        ele => ele.name === file.name
      )
      if (index > -1) {
        this.fileList.splice(index, 1)
      }
    },
    handleUpload() {
      const { fileList } = this
      if (fileList.length === 0) {
        return Promise.resolve([])
      } else {
        const formData = new FormData()
        fileList.forEach(file => {
          formData.append('files', file)
        })
        return upload(formData, progress => {
          this.completedProgress = progress
        }).then(res => {
          const data = res.data
          if (data.code === 200) {
            return Promise.resolve(data.result)
          }
        })
      }
    }
  }
}
